import React, { FunctionComponent } from 'react';
import { FieldRenderProps } from 'react-final-form';
import styled from 'styled-components';
import { InputField, Box, Tooltip, Text } from 'mdlkit';
import { FormattedMessage } from 'react-intl';

const StyledBox = styled(Box)`
  width: 100%;

  input {
    &:focus {
      box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #000000;
    }
  }
`;

type Props = { id: string } & FieldRenderProps<string, any>;

const EmailField: FunctionComponent<Props> = ({ meta, id, ...rest }: Props) => (
  <StyledBox>
    {meta.active ? (
      <Tooltip top width={200}>
        <Text bold>
          <FormattedMessage id="emailFieldTooltip.header" />
        </Text>
        <Text>
          <FormattedMessage id="emailFieldTooltip.body" />
        </Text>
      </Tooltip>
    ) : null}

    <InputField meta={meta} id={id} {...rest} />
  </StyledBox>
);

export default EmailField;
